import { FILTERS } from 'newJs/config';

export const FAN = FILTERS.get('ACTION_NAMES');

export const withTranslate = (translate) => (item) => {
    const { action, argument } = item;
    if (action !== 'move') return argument;

    const translation = translate(argument);
    const parts = translation.split('/');

    return translation === parts[0]
        ? translation
        : parts.slice(1).join('/');
};
